var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.open
    ? _c(
        "q-modal",
        {
          staticClass: "sl-modal users",
          attrs: {
            value: _vm.open,
            id: "details-modal",
            "no-esc-dismiss": true,
            "no-backdrop-dismiss": true,
            maximized: _vm.maximized,
            "content-css": {
              width: "1200px",
              maxWidth: "100%",
              minHeight: "85vh"
            }
          },
          on: {
            hide: function($event) {
              _vm.onClose()
            }
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c(
                    "q-toolbar-title",
                    [
                      _c("q-icon", { attrs: { name: "fa fa-user" } }),
                      _vm.mode === "add"
                        ? _c("span", [_vm._v("Add User")])
                        : _vm._e(),
                      _vm.mode === "edit"
                        ? _c("span", [
                            _vm._v(
                              "Edit User Details " + _vm._s(_vm.editUserLabel)
                            )
                          ])
                        : _vm._e(),
                      _vm.mode === "approve"
                        ? _c("span", [_vm._v("Approve Instructor")])
                        : _vm._e(),
                      _vm.mode === "approve" &&
                      this.activeApprovalHistory &&
                      this.activeApprovalHistory.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "label outline",
                              class: {
                                blue:
                                  this.activeApprovalStatus == "SUBMITTED" ||
                                  this.activeApprovalStatus == "RESUBMITTED",
                                green: this.activeApprovalStatus == "APPROVED",
                                red: this.activeApprovalStatus == "REJECTED"
                              },
                              staticStyle: {
                                display: "inline-block",
                                "margin-left": "10px",
                                "border-radius": "30px"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(this.activeApprovalStatus) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.mode === "approve" &&
                      this.activeApprovalStatus == "REJECTED" &&
                      this.activeApprovalNotes
                        ? _c(
                            "div",
                            { staticStyle: { display: "inline-block" } },
                            [
                              _c(
                                "q-icon",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: {
                                    name: "help_outline",
                                    outlined: "",
                                    color: "negative",
                                    size: "23px"
                                  }
                                },
                                [
                                  _c(
                                    "q-tooltip",
                                    {
                                      attrs: {
                                        anchor: "center right",
                                        self: "center left",
                                        offset: [10, 10]
                                      }
                                    },
                                    [_vm._v(_vm._s(this.activeApprovalNotes))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.mode === "approve" &&
                  this.activeApprovalHistory &&
                  this.activeApprovalHistory.length > 0
                    ? _c(
                        "q-btn-dropdown",
                        {
                          staticClass: "approval-history",
                          attrs: { icon: "access time" }
                        },
                        _vm._l(this.activeApprovalHistory, function(
                          approval,
                          i
                        ) {
                          return _c(
                            "q-list",
                            { key: i },
                            [
                              _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ]
                                },
                                [
                                  _c("q-item-side", {
                                    attrs: {
                                      icon: _vm.approvalDetail(approval, true)
                                    }
                                  }),
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.approvalDetail(approval)
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "q-item-tile",
                                        {
                                          attrs: {
                                            sublabel: "",
                                            title: _vm
                                              .moment(approval.DATE_CREATED)
                                              .format("llll")
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm
                                                  .moment(approval.DATE_CREATED)
                                                  .calendar()
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      )
                    : _vm._e(),
                  _vm.mode === "edit" &&
                  _vm.currentUser().USER_ID != _vm.userForm.USER_ID
                    ? _c(
                        "q-btn-dropdown",
                        { attrs: { icon: "more vert" } },
                        [
                          _c(
                            "q-list",
                            { attrs: { link: "" } },
                            [
                              _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ],
                                  attrs: { disable: _vm.savingUser },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.onRemove()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _c("q-icon", {
                                            attrs: {
                                              name: "fa fa-trash",
                                              color: "red"
                                            }
                                          }),
                                          _vm._v(" Delete User")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("q-icon", {
                    staticClass: "gt-sm",
                    attrs: { size: "20px", name: "filter_none" },
                    nativeOn: {
                      click: function($event) {
                        _vm.toggleMaximized()
                      }
                    }
                  }),
                  _c("q-icon", {
                    attrs: { name: "clear" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.onClose($event)
                      }
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "sl-row sl-abs" }, [
                _c(
                  "div",
                  { staticClass: "sl-col-3 navigation sl-vp" },
                  [
                    _c(
                      "q-list",
                      { attrs: { highlight: "" } },
                      [
                        _c(
                          "q-item",
                          {
                            class: { active: _vm.selectedTab === "general" },
                            nativeOn: {
                              click: function($event) {
                                _vm.updateSelectedTab("general")
                              }
                            }
                          },
                          [
                            _c("q-item-main", { attrs: { label: "General" } }),
                            _vm.validation.userForm.$invalid
                              ? _c("q-item-side", {
                                  staticClass: "flag-icon",
                                  attrs: { icon: "fa fa-flag", color: "red" }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          {
                            class: { active: _vm.selectedTab === "addresses" },
                            nativeOn: {
                              click: function($event) {
                                _vm.updateSelectedTab("addresses")
                              }
                            }
                          },
                          [
                            _c("q-item-main", {
                              attrs: { label: "Addresses" }
                            }),
                            _vm.validation.billingAddressForm.$invalid ||
                            _vm.validation.shippingAddressForm.$invalid
                              ? _c("q-item-side", {
                                  staticClass: "flag-icon",
                                  attrs: { icon: "fa fa-flag", color: "red" }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm.mode != "add"
                          ? _c(
                              "q-item",
                              {
                                class: {
                                  active: _vm.selectedTab === "documents"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.updateSelectedTab("documents")
                                  }
                                }
                              },
                              [
                                _c("q-item-main", {
                                  attrs: { label: "Documents" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.mode === "edit"
                          ? _c(
                              "q-item",
                              {
                                class: {
                                  active: _vm.selectedTab === "security"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.updateSelectedTab("security")
                                  }
                                }
                              },
                              [
                                _c("q-item-main", {
                                  attrs: { label: "Security" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.mode === "edit" &&
                        _vm.$p(["ADMIN", "MANAGER"], "or")
                          ? _c(
                              "q-item",
                              {
                                class: {
                                  active: _vm.selectedTab === "billing"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.updateSelectedTab("billing")
                                  }
                                }
                              },
                              [
                                _c("q-item-main", {
                                  attrs: { label: "Billing" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.mode === "edit"
                          ? _c(
                              "q-item",
                              {
                                class: {
                                  active: _vm.selectedTab === "notifications"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.updateSelectedTab("notifications")
                                  }
                                }
                              },
                              [
                                _c("q-item-main", {
                                  attrs: { label: "Notifications" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isInstructor && _vm.mode === "edit"
                          ? _c(
                              "q-item",
                              {
                                class: {
                                  active: _vm.selectedTab === "classes"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.updateSelectedTab("classes")
                                  }
                                }
                              },
                              [
                                _c("q-item-main", {
                                  attrs: { label: "Classes" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isAffiliate && _vm.$p(["ADMIN"])
                          ? _c(
                              "q-item",
                              {
                                class: {
                                  active: _vm.selectedTab === "managers"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.updateSelectedTab("managers")
                                  }
                                }
                              },
                              [
                                _c("q-item-main", {
                                  attrs: { label: "Managers" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.$p(["INSTRUCTOR"])
                          ? _c(
                              "q-item",
                              {
                                class: { active: _vm.selectedTab === "roles" },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.updateSelectedTab("roles")
                                  }
                                }
                              },
                              [
                                _c("q-item-main", {
                                  attrs: { label: "Roles" }
                                }),
                                _vm.validation.instructorForm.$invalid ||
                                _vm.validation.affiliateForm.$invalid ||
                                _vm.validation.affiliateForm.$invalid ||
                                _vm.validation.recruiterForm.$invalid
                                  ? _c("q-item-side", {
                                      staticClass: "flag-icon",
                                      attrs: {
                                        icon: "fa fa-flag",
                                        color: "red"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.mode === "edit"
                          ? _c(
                              "q-item",
                              {
                                class: { active: _vm.selectedTab === "notes" },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.updateSelectedTab("notes")
                                  }
                                }
                              },
                              [
                                _c("q-item-main", { attrs: { label: "Notes" } })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "sl-col-9 sl-vp",
                    staticStyle: {
                      "padding-bottom": "60px",
                      "overflow-x": "hidden"
                    },
                    attrs: { id: "class-modal-right" }
                  },
                  [
                    _vm.migrateOpen ? _c("migrate-instructor") : _vm._e(),
                    _vm.selectedTab === "general"
                      ? _c(
                          "div",
                          [
                            _c("user-details", {
                              attrs: { validation: _vm.validation }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.selectedTab === "addresses"
                      ? _c(
                          "div",
                          [
                            _c("user-addresses", {
                              attrs: { validation: _vm.validation }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.selectedTab === "documents"
                      ? _c(
                          "div",
                          [
                            _c("user-documents", {
                              attrs: { validation: _vm.validation }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.selectedTab === "security"
                      ? _c(
                          "div",
                          [
                            _c("user-security", {
                              attrs: { validation: _vm.validation }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.selectedTab === "billing"
                      ? _c(
                          "div",
                          [
                            _c("user-billing", {
                              attrs: { validation: _vm.validation }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.selectedTab === "notifications"
                      ? _c(
                          "div",
                          [
                            _c("user-notifications", {
                              attrs: { validation: _vm.validation }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.selectedTab === "classes"
                      ? _c(
                          "div",
                          [
                            _c("user-classes", {
                              attrs: { validation: _vm.validation }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.selectedTab === "managers"
                      ? _c(
                          "div",
                          [
                            _c("user-managers", {
                              attrs: { validation: _vm.validation }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.selectedTab === "roles"
                      ? _c(
                          "div",
                          [
                            _c("user-roles", {
                              attrs: { validation: _vm.validation }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.selectedTab === "notes"
                      ? _c(
                          "div",
                          [
                            _c("user-notes", {
                              attrs: { validation: _vm.validation }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c(
                "q-toolbar",
                {
                  staticClass: "sl-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  this.mode == "approve" &&
                  this.activeApprovalStatus != "APPROVED" &&
                  this.activeApprovalStatus != "REJECTED"
                    ? _c(
                        "div",
                        [
                          _c("q-btn", {
                            attrs: {
                              label: "Approve",
                              icon: "done",
                              color: "positive"
                            },
                            nativeOn: {
                              click: function($event) {
                                _vm.submitForApprovalMethod({
                                  id: _vm.activeApprovalId,
                                  status: 2
                                })
                              }
                            }
                          }),
                          _vm._v(" \n        "),
                          _c(
                            "q-btn-dropdown",
                            {
                              attrs: {
                                label: "Reject",
                                outline: "",
                                icon: "clear",
                                color: "negative"
                              }
                            },
                            [
                              _c(
                                "q-list",
                                { attrs: { id: "rejectionOverlay" } },
                                [
                                  _c("q-item", [
                                    _c(
                                      "div",
                                      { staticClass: "reject-notes" },
                                      [
                                        _c("q-input", {
                                          attrs: {
                                            "stack-label": "Rejection Notes*",
                                            type: "textarea",
                                            value: _vm.rejectionNotes
                                          },
                                          on: {
                                            input: function(val) {
                                              return _vm.updateRejectionNotes(
                                                val
                                              )
                                            }
                                          }
                                        }),
                                        _c("q-btn", {
                                          directives: [
                                            {
                                              name: "close-overlay",
                                              rawName: "v-close-overlay"
                                            }
                                          ],
                                          attrs: {
                                            label: "Reject",
                                            icon: "clear",
                                            color: "negative"
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.submitForApprovalMethod({
                                                id: _vm.activeApprovalId,
                                                status: 3
                                              })
                                            }
                                          }
                                        }),
                                        _c("q-btn", {
                                          directives: [
                                            {
                                              name: "close-overlay",
                                              rawName: "v-close-overlay"
                                            }
                                          ],
                                          attrs: {
                                            label: "Cancel",
                                            outline: ""
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("q-btn", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeApprovalStatus == "REJECTED",
                        expression: "activeApprovalStatus=='REJECTED'"
                      }
                    ],
                    attrs: {
                      color: "primary",
                      outline: "",
                      label: _vm.submitForApprovalLabel,
                      loading: _vm.submitting,
                      disabled: _vm.submitting
                    },
                    nativeOn: {
                      click: function($event) {
                        _vm.submitForApprovalMethod({
                          id: _vm.activeApprovalId
                        })
                      }
                    }
                  }),
                  _vm.$p(["ADMIN"]) && _vm.affiliateForm.ACTIVE_IND
                    ? _c(
                        "q-btn",
                        {
                          attrs: {
                            outline: "",
                            icon: "fa fa-magic",
                            color: "purple"
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.onSetMigrateOpen($event)
                            }
                          }
                        },
                        [_vm._v("\n          Migrate Instructor\n      ")]
                      )
                    : _vm._e(),
                  _vm._v("\n      " + _vm._s(_vm.migrateOpen) + "\n      "),
                  _c("q-toolbar-title"),
                  _vm.selectedTab === "documents"
                    ? _c(
                        "div",
                        { staticClass: "q-px-sm" },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.canUploadDocuments) +
                              "\n        "
                          ),
                          _vm.canUploadDocuments
                            ? _c("q-btn", {
                                staticClass: "q-px-md",
                                attrs: {
                                  label: "Upload",
                                  color: "green",
                                  disable: _vm.savingUser
                                },
                                on: {
                                  click: function($event) {
                                    _vm.openUploadModal()
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.mode === "edit"
                    ? _c(
                        "div",
                        { staticClass: "q-px-sm" },
                        [
                          _c("q-btn", {
                            staticClass: "q-px-md",
                            attrs: {
                              color: "green",
                              label: "Save",
                              disable: _vm.validation.$invalid || _vm.savingUser
                            },
                            on: {
                              click: function($event) {
                                _vm.onUpdate()
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.mode === "add"
                    ? _c(
                        "div",
                        { staticClass: "q-px-sm" },
                        [
                          _c("q-btn", {
                            staticClass: "q-px-md",
                            attrs: {
                              color: "green",
                              label: "Add",
                              disable: _vm.validation.$invalid || _vm.savingUser
                            },
                            on: {
                              click: function($event) {
                                _vm.onAdd()
                              }
                            }
                          }),
                          _vm._v("  \n      ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("q-btn", {
                    attrs: {
                      outline: "",
                      color: "faded",
                      label: "Cancel",
                      disable: _vm.savingUser
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.closeDetails($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "q-inner-loading",
            { attrs: { visible: _vm.savingUser } },
            [
              _c("q-spinner-puff", { attrs: { color: "primary", size: "70" } }),
              _c("span", [_vm._v("Saving User..")])
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }